import { Button } from '@chakra-ui/react';
import { MdChecklist } from 'react-icons/md';

export interface BulkEditButtonProps {
  onClick: () => void;
  isVisible?: boolean;
}

export default function BulkEditButton({
  onClick,
  isVisible = true
}: BulkEditButtonProps) {
  if (!isVisible) {
    return null;
  }

  return (
    <Button
      position="fixed"
      bottom="100px"
      left="50%"
      transform="translateX(-50%)"
      h="60px"
      w="60px"
      borderRadius="50%"
      colorScheme="blue"
      onClick={onClick}
      zIndex={99}
      shadow="lg"
    >
      <MdChecklist size={24} />
    </Button>
  );
}
